import axios from 'axios'
import ViewerConfig from 'utils/viewerConfig'

const UserCall = {
  async getUserFlags(userId) {
    if (!userId || ViewerConfig.isPreview() || ViewerConfig.isOpen() || ViewerConfig.isLocal()) {
      return null
    }
    const url = `${window.viewer.api}users/${userId}/userFlags`
    try {
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      return null
    }
  },
  async getUserPreferences() {
    const url = `${window.viewer.api}userPreferences`
    const response = await axios.get(url)
    return response.data
  },
  async updateUserFlags(userId, userFlagName, userFlagValue) {
    if (!userId || !userFlagName) {
      return null
    }
    const url = `${window.viewer.api}users/${userId}/usersFlags/${userFlagName}`
    try {
      const response = await axios.put(url, { value: userFlagValue })
      return response
    } catch (error) {
      return error
    }
  },

  async updateUserPreferences(userPreferences) {
    const url = `${window.viewer.api}userPreferences`
    const response = await axios.patch(url, userPreferences)
    return response
  },
}
export default UserCall
